// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ebc8ad62","488":"57887ac5","977":"ab6d79e1"}[chunkId] + ".chunk.js";
};